import * as React from 'react';
import { FormField } from '@cian/ui-kit/form';
import { Input, IInputProps } from '@cian/ui-kit/input';

import { Label } from '../Label';
import { EPostFormFieldName } from '../../../types/postForm';

interface IFeaturedImageField {
  value: Required<IInputProps['value']>;
  onChange(value: Required<IInputProps['value']>): void;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  strong?: boolean;
  withoutMargin?: boolean;
  size?: 'M' | 'XS';
}

/**
 * Поле Обложка поста
 */
export const FeaturedImageField = ({
  value,
  errorMessage,
  disabled,
  required,
  onChange,
  label,
  strong,
  withoutMargin,
  size,
}: IFeaturedImageField) => {
  return (
    <FormField errorMessage={errorMessage} withoutMargin={withoutMargin}>
      <Label required={required} label={label ?? 'Обложка'} strong={strong}>
        <Input
          name={EPostFormFieldName.Title}
          value={value}
          type="text"
          invalid={Boolean(errorMessage)}
          disabled={disabled}
          size={size ?? 'M'}
          onChange={(_e, value) => onChange(value)}
        />
      </Label>
    </FormField>
  );
};
